import Vue from "vue";
// @ts-ignore
import VueGoogleCharts from "vue-google-charts/legacy";

Vue.use(VueGoogleCharts);
